import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import AuthContextProvider from "./Context/AuthContext";
import { CookiesProvider } from "react-cookie";
import LinksquaredContextProvider from "./Context/LinksquaredContext";
import DeepLinkComponent from "./Components/Deeplinking/DeepLinkComponent";
import GenericComponentsContextProvider from "./Context/GenericComponentsStateContext";
import CallsContextProvider from "./Context/CallsContext";
import WebSocketServiceProvider from "./Context/WebsocketContext";
import MeetingsContextProvider from "./Context/MeetingContext";
import ConferencesContextProvider from "./Context/ConferenceContext";
import ConversationContextProvider from "./Context/ConversationsContext";
import TolgeeContextProvider from "./Context/TolgeeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <LinksquaredContextProvider>
    <TolgeeContextProvider>
      <AuthContextProvider>
        <ConversationContextProvider>
          <GenericComponentsContextProvider>
            <CallsContextProvider>
              <MeetingsContextProvider>
                <ConferencesContextProvider>
                  <HashRouter>
                    <WebSocketServiceProvider>
                      <CookiesProvider defaultSetOptions={{ path: "/" }}>
                        <DeepLinkComponent />
                        <App />
                      </CookiesProvider>
                    </WebSocketServiceProvider>
                  </HashRouter>
                </ConferencesContextProvider>
              </MeetingsContextProvider>
            </CallsContextProvider>
          </GenericComponentsContextProvider>
        </ConversationContextProvider>
      </AuthContextProvider>
    </TolgeeContextProvider>
  </LinksquaredContextProvider>
);
